module.exports = __webpack_public_path__ + "static/media/color.a3dc163b.webp";